import { isNil } from "lodash";

import type { ColumnsType, AnyObject } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";
import { NO_DATA_SIGN } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";

import { SearchOverviewTexts } from "../../texts";
import type { FormattedNumber } from "../../types";
import { CellWithLeftPadding } from "../OrganicPaidTable/styledComponents";
import { renderChangeCell, renderDomainCell } from "../TableCells/tableCells";

import { PercentageValue, ProgressBarWrapper } from "./styledComponent";

const { carbon } = colorsPalettes;

export const getRankPositionColumns = (): ColumnsType<AnyObject> =>
    [
        {
            title: <CellWithLeftPadding>{translate("analysis.source.search.overview.domain")}</CellWithLeftPadding>,
            dataIndex: "domain",
            width: 156,
            render: renderDomainCell,
        },
        {
            title: translate(SearchOverviewTexts.keywords),
            dataIndex: "keywords",
            width: 72,
            align: "right",
            render: (keywords: string) => (keywords ? <div>{keywords}</div> : NO_DATA_SIGN),
        },
        {
            title: translate(SearchOverviewTexts.momChange),
            dataIndex: "change",
            width: 92,
            align: "right",
            render: (change) => renderChangeCell(change),
        },
        {
            title: translate("analysis.source.search.overview.widgets.ofsitekeywords"),
            dataIndex: "percentageOf",
            width: 100,
            render: (percentageOf: FormattedNumber) => {
                if (isNil(percentageOf?.numericValue) || isNil(percentageOf?.formattedValue)) {
                    return NO_DATA_SIGN;
                }

                return (
                    <ProgressBarWrapper>
                        <PercentageValue>{percentageOf.formattedValue}</PercentageValue>
                        <ProgressBar
                            width={percentageOf.numericValue}
                            className="u-full-width"
                            isCompare={true}
                            height={8}
                            backgroundColor={carbon[50]}
                        />
                    </ProgressBarWrapper>
                );
            },
        },
    ] as ColumnsType<AnyObject>;
